import { ChildForm } from "./ChildForm";

interface EditChildFormProps {
  childId: string;
  initialData: {
    name: string;
    age: number;
    birthday?: string;
    profile_picture_url?: string | null;
  };
  onSuccess?: () => void;
}

export const EditChildForm = ({ childId, initialData, onSuccess }: EditChildFormProps) => {
  return (
    <ChildForm
      mode="edit"
      childId={childId}
      initialData={initialData}
      onSuccess={onSuccess}
    />
  );
};